import React, { useState } from "react";
import Seller from "../components/Seller";
import FruitStand from "../components/FruitStand";
import Basket from "../components/Basket";
import PurchaseTask from "../components/PurchaseTask";
import PayButton from "../components/PayButton";
import "./LevelOne.css";
import { useNavigate } from "react-router-dom";
import confetti from "canvas-confetti";
import eclipse from "../assets/splash-eclipse.png";

function speak(text) {
  if ("speechSynthesis" in window) {
    const utterance = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(utterance);
  } else {
    console.warn("Speech synthesis not supported");
  }
}

const fruits = [
  { name: "banana", emoji: "🍌", price: 2 },
  { name: "orange", emoji: "🍊", price: 3 },
  { name: "strawberry", emoji: "🍓", price: 1 },
  { name: "apple", emoji: "🍎", price: 2 },
];

const task = { banana: 2, orange: 3 };

const LevelOne = () => {
  const [basket, setBasket] = useState({
    banana: 0,
    orange: 0,
    strawberry: 0,
    apple: 0,
  });

  const navigate = useNavigate();

  // Add fruit to basket
  const addToBasket = (fruitName) => {
    speak(`Added ${fruitName}`);
    setBasket((prev) => ({
      ...prev,
      [fruitName]: (prev[fruitName] || 0) + 1,
    }));
  };

  // Remove fruit from basket (cannot go below 0)
  const removeFromBasket = (fruitName) => {
    speak(`Removed ${fruitName}`);
    setBasket((prev) => ({
      ...prev,
      [fruitName]: Math.max((prev[fruitName] || 0) - 1, 0),
    }));
  };

  const handlePay = () => {
    const hasCorrectFruits = Object.entries(task).every(
      ([fruit, count]) => basket[fruit] === count
    );

    if (hasCorrectFruits) {
      alert("✅ Great job! You added the right fruits!");
      confetti();
      navigate("/pay"); // ⬅️ navigate to PayScreen
    } else {
      alert("Please drag and drop the exact number of items mentioned");
    }
  };

  const handleBack = () => {
    navigate("/levels");
  };

  return (
    <div
      className="level-one-container"
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* Eclipse background */}
      <img src={eclipse} alt="Background shape" className="levelone-eclipse" />

      <button onClick={handleBack} className="back-button">
        ← Back
      </button>

      <PurchaseTask task={task} basket={basket} />
      <Seller />
      <p>Drag and drop the fruits to the basket</p>
      <FruitStand fruits={fruits} onAdd={addToBasket} />

      <div
        className="basket-pay-wrapper"
        style={{
          display: "flex",
          gap: "20px",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
          maxWidth: 1000,
        }}
      >
        <Basket
          basket={basket}
          onDropFruit={addToBasket}
          onRemove={removeFromBasket}
        />

        <PayButton onPay={handlePay} />
      </div>
    </div>
  );
};

export default LevelOne;
